@if (!dialogService.isOpen()) {
  <button
    type="button"
    class="fixed bottom-6 right-6 z-40 btn btn-circle btn-primary btn-lg shadow-lg"
    aria-label="Assistent öffnen"
    (click)="open()"
  >
    <fa-icon [icon]="faCommentDots" size="lg"></fa-icon>
  </button>
}
